import React from 'react'

import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { ListActionsDialogActions } from '@components/dialogs'
import { AsyncButton, Button, CustomDialog, FlexRow, Typography } from '@components/ui'

import { NavM2MConsentView } from './ConsentViews'
import { CompanyConsentTypes } from './types'

import { AttentionDialogCloseButtonMessage, CancelButtonMessage } from '@messages'

const ButtonsContainer = styled(FlexRow)`
  justify-content: center;
  gap: 8px;
`

interface CompanyConsentDialogProps {
  error: BackendError
  forced?: boolean
  isAdminUser: boolean
  loading: boolean
  onClose: VoidFunction
  onConfirm: VoidFunction
  open: boolean
  consentType: Nullable<CompanyConsentTypes>
}

export function CompanyConsentDialog({
  error,
  forced = false,
  isAdminUser,
  loading,
  onClose,
  onConfirm,
  open,
  consentType,
}: CompanyConsentDialogProps) {
  const [isAccepted, setAccepted] = React.useState(false)

  React.useEffect(() => {
    if (!open) {
      setAccepted(false)
    }
  }, [open])

  return (
    <CustomDialog open={open} onClose={onClose} shouldCloseOnEsc={!forced} shouldCloseOnOverlayClick={!forced}>
      {consentType === CompanyConsentTypes.NAV_M2M_INTEGRATION && <NavM2MConsentView onAcceptedChange={setAccepted} />}
      <ListActionsDialogActions borderless>
        {error && (
          <Typography color="error" size="400-sm">
            {error}
          </Typography>
        )}
        <ButtonsContainer>
          {isAdminUser ? (
            <>
              {!forced && (
                <Button variant="secondaryContained" onClick={onClose}>
                  {CancelButtonMessage}
                </Button>
              )}
              <AsyncButton variant="primaryContained" loading={loading} onClick={onConfirm} disabled={!isAccepted}>
                <FormattedMessage id="dialogs.companyConsent.buttons.confirm" defaultMessage="Engedélyezem" />
              </AsyncButton>
            </>
          ) : (
            !forced && (
              <Button variant="secondaryContained" onClick={onClose}>
                {AttentionDialogCloseButtonMessage}
              </Button>
            )
          )}
        </ButtonsContainer>
      </ListActionsDialogActions>
    </CustomDialog>
  )
}
